// R82 — **"ESCAPE CLOSES THIS" IS THE KEYBOARD PROMISE EVERY MODAL ON THIS SITE MAKES, AND IT WAS
// TYPED BY HAND ELEVEN TIMES IN FIVE DIFFERENT SPELLINGS.**
//
// 14-B7d(3) folded eight byte-for-byte copies into a hook and left the hook inside App.tsx, where a
// component in `src/components` cannot import it — **so every modal that has moved out of App.tsx
// since has had to re-type the law to keep its own promise.** That is the whole reason there were
// two more of it waiting out here. The hook lives beside the components now, and App.tsx imports it
// back like any other extraction.
//
// **THE COUNT WAS THE FINDING AND TWO OF THE COPIES HAD ALREADY DRIFTED (R47).** `CardZoomOverlay`
// listed NO dependency at all (`}, []`), so its listener captured the first `onClose` it was ever
// handed and every later one was ignored; `PageImageReader` depends on `[total]`, which is not
// `onClose` either. Neither throws, neither logs, and the symptom is the one this house keeps
// paying for: a key that does nothing, on a control with no error state.
//
// **`onClose` IS OPTIONAL, AND ITS ABSENCE IS THE ANSWER RATHER THAN A MISSING ARGUMENT** (R27's
// optional-prop shape, argued rather than drifted). `ModalBackdrop` guards on `if (!onClose)` and
// `EdgeDrawer` on `if (!open)` — a modal that must not be dismissible — and both were counted as a
// DIFFERENT law for exactly as long as this hook could only say yes. It says both now: a backdrop
// with no `onClose` and a drawer that is shut hand it `undefined` and no listener is attached.
//
// **WHAT IS NOT FOLDED IN IS DECLARED BY NAME IN `scripts/r82-escape-law.mjs`, WITH ITS REASON**,
// because the roster this replaced was a byte-for-byte regex and **a roster whose predicate cannot
// contain the thing reports "all declared" forever** (R69). Three surfaces answer other keys in the
// same handler, two listen on `document` (one of them stops propagation on purpose, which is what
// keeps a nested overlay from closing the room behind it), and two are field-scoped `onKeyDown`s
// that cancel an edit rather than close anything.
import { useEffect } from "react";

export function useEscapeKey(onClose: (() => void) | undefined) {
  useEffect(() => {
    if (!onClose) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
}
